<template>
    <div class="button-title" :class="$mq">
      <!--
      <buttonBDD :data = data />
      <buttonMail :data = data />
      -->
    </div>
</template>

<script>
//import buttonBDD from "./buttonBDD"
//mport buttonMail from "./buttonMail"

export default {
  name: "resultButtons",

  components: {
    //buttonMail,
    //buttonBDD
  },

  props: {
    data: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import "../../utilities/variables";

.button-title {
  display: flex;
  justify-content: center;
}

.button-title.smartphone {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
